import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { TranslateEditDialogComponent, TranslateEditDialogData } from '@app/modal/translate-edit-dialog/translate-edit-dialog.component';
import { EconomyService } from '@app/services/economy.service';
import { LogisticService, StockLocation } from '@app/services/logistic.service';

@Component({
    selector: 'tt-pick-job-group',
    templateUrl: './pick-job-group.component.html',
    styleUrls: ['./pick-job-group.component.css'],
})
export class PickJobGroupComponent implements OnInit {
    private stockplaceId: string;

    public pickJobGroupKeyno: string;

    public get?: PickJobGroupGet;

    public stockLocations: StockLocation[] = [];

    public trolleys: Item[] = [];

    public businessSites: Item[] = [];

    public pickJobGroupNameButtons: FormButton[] = [{ id: 'translate', icon: 'far fa-language', type: 'primary', onClick: () => this.openTranslationDialog() }];

    public saving: boolean = false;

    public deleting: boolean = false;

    private translations: { [key: string]: string } = { error: '' };

    constructor(private datatask: DataTaskService, private state: StateService, private logistic: LogisticService, private economy: EconomyService, private dialog: MatDialog, private translate: TranslateService, private modal: ModalService) {
        this.stockplaceId = this.state.getStateParams()['stockplace_id'];
        this.pickJobGroupKeyno = this.state.getStateParams()['pickjobgrp_keyno'];
    }

    public async save() {
        try {
            this.saving = true;

            const { errorcode, errormessage } = await this.savePickJobGroup();

            if (errorcode !== '0') {
                this.modal.show({ title: this.translations['error'], message: errormessage, type: 'warning' });
            } else {
                this.state.back();
            }
        } finally {
            this.saving = false;
        }
    }

    public async delete() {
        try {
            this.deleting = true;

            const { errorcode, errormessage } = await this.deletePickJobGroup();

            if (errorcode !== '0') {
                this.modal.show({ title: this.translations['error'], message: errormessage, type: 'warning' });
            } else {
                this.state.back();
            }
        } finally {
            this.deleting = false;
        }
    }

    public openTranslationDialog = async () => {
        if (!!this.get) {
            const edits = await this.datatask.Post(3607, { pickjobgrp_keyno: this.get.pickjobgrp_keyno });
            const dialogRef = this.dialog.open(TranslateEditDialogComponent, {
                width: '120rem',
                maxWidth: '95vw',
                height: '80vh',
                data: <TranslateEditDialogData<PickJobGroupLangEdit>>{
                    heading: `(${this.get.stockplace_name}) ${this.get.pickjobgrp_name}`,
                    textToTranslate: this.get.pickjobgrp_name,
                    edits: edits,
                    save: async (data) => {
                        console.log(data);
                        await this.datatask.Post(3608, { edits: data.edits });
                        await this.loadPageGet();
                        dialogRef.close();
                    },
                    wordNameKey: 'pickjobgrp_name',
                    wordIdKey: 'pickjobgrp_keyno',
                },
            });
        }
    };

    private async savePickJobGroup(): Promise<{ errorcode: string; errormessage: string }> {
        if (!!this.get) {
            return (await this.datatask.Post(2167, this.get))[0];
        }

        throw Error('pick job group not found');
    }

    private async deletePickJobGroup(): Promise<{ errorcode: string; errormessage: string }> {
        if (!!this.pickJobGroupKeyno) {
            return (await this.datatask.Post(3606, { pickjobgrp_keyno: this.pickJobGroupKeyno }))[0];
        }

        throw Error('pick job group keyno required');
    }

    private async loadPageGet() {
        if (!!this.stockplaceId && !!this.pickJobGroupKeyno) {
            this.get = (await this.datatask.Post(2166, { stockplace_id: this.stockplaceId, pickjobgrp_keyno: this.pickJobGroupKeyno }))[0];
        }
    }

    private async loadStockLocations() {
        if (!!this.stockplaceId) {
            this.stockLocations = await this.logistic.getStockLocations(this.stockplaceId);
        }
    }

    private async loadTrolleys() {
        if (!!this.stockplaceId) {
            this.trolleys = await this.logistic.getTrolleys({ stockplace_id: this.stockplaceId });
        }
    }

    private async loadBusinessSites() {
        this.businessSites = await this.economy.getBusinessSites({ add_all: '1' });
    }

    private async translateWords() {
        const data = await this.translate.translateBatch(Object.keys(this.translations));

        Object.keys(data).forEach((key) => (this.translations[key] = data[key]));
    }

    ngOnInit(): void {
        this.loadPageGet();
        this.loadStockLocations();
        this.loadTrolleys();
        this.loadBusinessSites();
        this.translateWords();
    }
}

interface PickJobGroupGet {
    pickjobgrp_keyno: string;
    pickjobgrp_name: string;
    stockplace_id: string;
    stockplace_name: string;
    std_stocklocation_keyno_unload: string;
    stocklocation_keyno_trolley: string;
    businesssite_keyno: string;
    businessco_no: string;
    is_active: '1' | '0';
}

interface PickJobGroupLangEdit extends Record<string, string> {
    pickjobgrp_keyno: string;
    pickjobgrp_name: string;
    language_id: string;
    language_name: string;
    orderby: string;
    google_language_id: string;
}
